module.exports = {
    PROJECT_EXPENSE_TYPES: [
        "HOUSE RENTING",                    // Alquiler de vivienda
        "HOSTEL ACCOMMODATION",             // Alojamiento en albergues
        "FOOD",                             // Manutención
        "GAS",                              // Gas
        "NATIONAL AND INTERNATIONAL TRAVELS", // Viajes nacionales e internacionales
        "MILEAGE",                          // Kilometraje
        "LOCAL TRANSPORT RENTAL",           // Alquiler transporte local
        "CES SHIPPING COSTS",               // Gastos de envío CES
        "CLASSES",                          // Clases
        "WORKERS TRAINING",                 // Formación de trabajadores
        "MOOC PLATFORM",                    // Plataforma MOOC
        "TRAINING ACTIVITIES",              // Actividades de formación 
        "SUPPORT FOR INCLUSION",            // Apoyo para la inclusión
        "MATERIALS",                        // Materiales
        "VISIBILITY",                       // Visibilidad
        "WEB HOSTING AND DOMAIN",           // Hosting web y dominio
        "LEGAL AND ADMINISTRAVIVE COSTS",   // Costes legales y administrativos        
        "MANAGMENT COSTS",                  // Costes de gestión
        "ACCOUNTING ADVICE",                // Asesoría contable
        "LEGAL ADVICE",                     // Asesoría jurídica
        "OCCUPATIONAL RISK MANAGMENT",      // Gestión de riesgos laborales
        "TELECOMMUNICATIONS",               // Telecomunicaciones
        "DIGITAL SUBSCRIPTIONS",            // Suscripciones digitales
        "LICENSES AND SOFTWARE",            // Licencias y software
        "SALARIES AND FEES",                // Salarios y honorarios
        "OUTSOURCING OF PROFESIONAL SERVICES", // Subcontratación de servicios profesionales
        "GROUP LEADER",                     // Líder de grupo        
        "KA2 - PROJECT MANAGEMENT COSTS",   // KA2 - Costes de gestión del proyecto
        "KA2 - INTELLECTUAL OUTPUTS (IO)",  // KA2 - Resultados intelectuales (IO)
        "KA2 - MULTIPLIER EVENTS",          // KA2 - Eventos multiplicadores
        "CES - SUPPORT FOR INCLUSION",      // CES - Apoyo para la inclusión
        "CES - EXCEPTIONAL COSTS",          // CES - Costes excepcionales
        "CES - WATER, ELECTRICITY, HEATING",// CES - Agua, luz, calefacción
        "INDIRECT COSTS",                   // Costes indirectos
        "POSTAGE AND COURIER SERVICES",     // Correos y mensajería
        "OTHER UNCLASSIFIED EXPENSES"       // Otros gastos no clasificados
    ],
    PROJECT_EXPENSE_DEFAULT_TYPE: "OTHER UNCLASSIFIED EXPENSES",
    GENERAL_EXPENSE_TYPES: [
        "CONSUMABLE",      // Consumibles
        "CONTRACTORS",     // Servicios contratados externos
        "DONATIONS",       // Donativos y actos de caridad
        "HARDWARE",        // Equipos físicos
        "INSURANCE",       // Pólizas de seguro
        "IRPF",            // Impuesto sobre la renta de las personas físicas    
        "LEGAL",           // Servicios legales y auditorías
        "LICENSES",        // Permisos y licencias
        "MAINTENANCE",     // Mantenimiento de instalaciones y equipos
        "MARKETING",       // Publicidad y promoción
        "MATERIALS",       // Materiales
        "MEDICAL",         // Gastos médicos
        "OTHERS",          // Otros gastos
        "RECEIPTS",        // Recibís
        "RENT",            // Alquileres de espacios o equipos        
        "SERVICES",        // Servicios generales
        "SOFTWARE",        // Licencias y desarrollo
        "STAFF",           // Sueldos y beneficios de empleados
        "SUBSCRIPTIONS",   // Suscripciones a servicios
        "TAXES",           // Pagos fiscales y tributarios
        "TRAINING",        // Formación del personal
        "TRANSPORT",       // Transporte
        "TRAVEL",          // Viajes
        "UNEXPECTED",      // Gastos imprevistos
        "UTILITIES"        // Agua, luz, gas, internet, etc.
    ],
    GENERAL_EXPENSE_DEFAULT_TYPE: "OTHERS",
}